import * as styles from './styles';
import { translate } from 'react-i18next';

export default translate()(
  ({
    i18n,
    input,
    label,
    type,
    placeholder,
    isRequired = true,
    disabled,
    notification,
    max,
    password,
    style,
    commonError,
    meta: { touched, error, active } = {}
  }) => {
    return (
      <div style={{ marginBottom: '20px', textAlign: 'left', ...style }}>
        {/* Label */}

        <styles.InputLabel className="input-label">
          {label}
          {isRequired && <styles.Required> *</styles.Required>}
          {password &&
            password.isForgot && (
            <styles.ForgotLink to="/forgot">Forgot password?</styles.ForgotLink>
          )}
        </styles.InputLabel>

        {/* Input */}

        {password ? (
          <styles.PasswordBlock>
            <styles.Input
              {...input}
              placeholder={placeholder}
              error={commonError || (error && touched)}
              active={active}
              type={type}
              maxLength={max || 100}
              style={{ paddingRight: '35px' }}
            />
            {password.isView ? (
              <styles.ViewPasswordImg onClick={password.show} />
            ) : (
              <styles.HidePasswordImg onClick={password.show} />
            )}
          </styles.PasswordBlock>
        ) : (
          <div>
            <styles.Input notPassword
              className="ym-disable-keys"
              {...input}
              placeholder={placeholder}
              type={type}
              disabled={disabled}
              active={active}
              error={commonError || (error && touched)}
              maxLength={max || 100}
            />

            {/* <input returnKeyType={'next'} onBlur={input.onBlur} onFocus={input.onFocus} /> */}
          </div>
        )}

        {/* Errors */}

        {touched &&
          error &&
          !active && (
          <styles.ErrorMessage className="input-field-error">{typeof error === 'string' && i18n.t(error)}</styles.ErrorMessage>
        )}

        {/* Notification */}

        {notification && <styles.InputNotification>{notification}</styles.InputNotification>}
      </div>
    );
  }
);
